var render = function render() {
  var _vm$balanceCheck;
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('modal-overlay', {
    attrs: {
      "open": _vm.open
    }
  }, [(_vm$balanceCheck = _vm.balanceCheck) !== null && _vm$balanceCheck !== void 0 && _vm$balanceCheck.insufficient && !_vm.balanceCheck.bypassPlaidBalanceCheck ? _c('div', {
    staticClass: "modal-content px-4 pt-12 pb-8 flex flex-col text-center"
  }, [_c('h3', [_vm._v("Our checks show you do not have a sufficient account balance.")]), _vm._v(" "), _c('p', {
    staticClass: "mt-5"
  }, [_vm._v("\n\t\t\tThe plan you selected exceeds your reported account balance. Please add additional funds to\n\t\t\tyour account or choose an alternative plan.\n\t\t")]), _vm._v(" "), _c('button', {
    key: 'complete',
    staticClass: "button--filled mt-6 mx-4",
    attrs: {
      "name": "submit-plan"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('update:balanceCheck', {});
      }
    }
  }, [_vm._v("\n\t\t\tChange plan\n\t\t")])]) : _c('pricing-section', {
    staticClass: "modal-content",
    attrs: {
      "title": "Select your plan",
      "all-plans": _vm.plans,
      "billing-cycle": _vm.planPickerCycle,
      "selected-plan": _vm.planPickerPlan,
      "show-features": false,
      "continue-button-title": "Change plan",
      "continue-button-action": _vm.changePlanIfSufficient,
      "footer": "",
      "wrap-slot": true
    },
    on: {
      "update:billingCycle": function ($event) {
        _vm.planPickerCycle = $event;
      },
      "update:billing-cycle": function ($event) {
        _vm.planPickerCycle = $event;
      },
      "update:selectedPlan": function ($event) {
        _vm.planPickerPlan = $event;
      },
      "update:selected-plan": function ($event) {
        _vm.planPickerPlan = $event;
      }
    },
    scopedSlots: _vm._u([{
      key: "button",
      fn: function () {
        return [_c('button', {
          staticClass: "button--white mt-6 mx-4 w-full",
          attrs: {
            "name": "change-bank"
          },
          on: {
            "click": _vm.changeBank
          }
        }, [_vm._v("\n\t\t\t\tChange connected account\n\t\t\t")])];
      },
      proxy: true
    }])
  }, [_c('img', {
    staticClass: "plan-picker-close-button cursor-pointer box-content absolute top-0 right-0 p-4",
    attrs: {
      "src": require("assets/images/close.svg"),
      "width": "14px",
      "height": "14px",
      "draggable": "false"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('update:open', false);
      }
    }
  })])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };